import { Icon } from "./Icon.tsx";

/** "Zoom to full extent" — four corner brackets around empty space, the standard GIS "fit everything in view" glyph (GeoreferencedMap.tsx's own zoom control). Distinct from TargetIcon's crosshair ("pick a point on the map"). */
export function ZoomExtentIcon() {
  return (
    <Icon>
      <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />
    </Icon>
  );
}
